import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Dot } from '../../common/Dot';
import Box from '@mui/material/Box';
import { jsx as _jsx } from "react/jsx-runtime";
export function IndicatorBadgeDot(props) {
  var _props$intent = props.intent,
    intent = _props$intent === void 0 ? 'success' : _props$intent,
    _props$size = props.size,
    size = _props$size === void 0 ? 'xs' : _props$size,
    sx = props.sx;
  var theme = useTheme();
  var bgColor = {
    error: {
      color: theme.palette.error[500]
    },
    neutral: {
      color: theme.palette.gray[400]
    },
    primary: {
      color: theme.palette.primary[500]
    },
    success: {
      color: theme.palette.success[500]
    },
    warning: {
      color: theme.palette.warning[400]
    }
  };
  return /*#__PURE__*/_jsx(Box, {
    border: "1.5px solid ".concat(theme.palette.common.white),
    borderRadius: "50%",
    width: "fit-content",
    "data-element": "Box",
    "data-component": "IndicatorBadgeDot",
    "data-source-file": "IndicatorBadgeDot.tsx",
    children: /*#__PURE__*/_jsx(Dot, {
      color: bgColor[intent].color,
      size: dotSize[size].size,
      sx: _extends({}, sx),
      "data-element": "Dot",
      "data-source-file": "IndicatorBadgeDot.tsx"
    })
  });
}
var dotSize = {
  '2xl': {
    borderRadius: '8px',
    size: 16
  },
  lg: {
    borderRadius: '6px',
    size: 12
  },
  md: {
    borderRadius: '5px',
    size: 10
  },
  sm: {
    borderRadius: '4px',
    size: 8
  },
  xl: {
    borderRadius: '7px',
    size: 14
  },
  xs: {
    borderRadius: '3px',
    size: 6
  }
};